import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
} from '@angular/core';
import { LocalizedDateFns } from '../localized-date-fns.service';

@Component({
  selector: 'fl-relative-time',
  template: `
    {{relativeTime | async}}
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RelativeTimeComponent implements OnInit, OnChanges {
  @Input() time: number;
  relativeTime: Promise<string>;

  constructor(private dateFns: LocalizedDateFns) {}

  ngOnInit() {
    this.updateRelativeTime();
  }

  ngOnChanges() {
    this.updateRelativeTime();
  }

  private updateRelativeTime() {
    this.relativeTime = this.dateFns.formatDistance(this.time, new Date(), {
      addSuffix: true,
    });
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/de/webapp/src/app/@shared/ui/relative-time/relative-time.component.ts